import React from 'react';

import { useHasPermission } from '@vlabs/permissions';

import { CardGeneralInfo } from '../card-general-info';
import { CardFacesViewer } from './card-faces-viewer';
import { CardPageHeader } from './card-page-header';
// ponytail: temporarily disabled files, GUI-3979 — import { PersonFiles } from '../person-files';
import { PersonLists } from '../person-lists';
import st from './CardPageContent.module.sass';

export function CardPageContent(): React.JSX.Element {
  const canReadLists = useHasPermission('list', 'read');
  // ponytail: temporarily disabled files, GUI-3979 — const canReadFiles = useHasPermission('card_document', 'read');

  return (
    <div className={st.CardPageContent}>
      <CardPageHeader />

      <div className={st.Layout}>
        <div className={st.Sidebar}>
          <div className={st.SidebarContent}>
            <CardGeneralInfo />
            {!!canReadLists && <PersonLists />}
            {/* ponytail: temporarily disabled files, GUI-3979 — {!!canReadFiles && <PersonFiles />} */}
          </div>
        </div>

        <div className={st.Main}>
          <CardFacesViewer />
        </div>
      </div>
    </div>
  );
}
